import script from "./VerificarCertificado.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificarCertificado.vue?vue&type=script&setup=true&lang=js"

import "./VerificarCertificado.vue?vue&type=style&index=0&id=3e49e8e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e49e8e1"]])

export default __exports__